<template>
  <div>
    <b-container class=" px-0 mx-0" fluid>
      <div class="position-relative">
        <b-img fluid-grow :src="require('../assets/immagini/img-top.jpg')" alt="img top" class="mx-0 d-none d-sm-block" style="background-color:#fff"></b-img>
        <b-img fluid-grow :src="require('../assets/immagini/img-top-xs.jpg')" alt="img top" class="mx-0 d-sm-none"></b-img>
        <!-- <div class="position-absolute cva-energie-academy-logo">
          <b-img class="d-none d-xl-block" :src="require('../assets/immagini/cva-energie-academy-logo.svg')" alt="cva-energie-academy-logo" height="220"></b-img>
          <b-img class="d-none d-lg-block d-xl-none" :src="require('../assets/immagini/cva-energie-academy-logo.svg')" alt="cva-energie-academy-logo" height="190"></b-img>
          <b-img class="d-none d-md-block d-lg-none" :src="require('../assets/immagini/cva-energie-academy-logo.svg')" alt="cva-energie-academy-logo" height="160"></b-img>
          <b-img class="d-none d-sm-block d-md-none" :src="require('../assets/immagini/cva-energie-academy-logo.svg')" alt="cva-energie-academy-logo" height="120"></b-img>
          <b-img class="d-sm-none" :src="require('../assets/immagini/cva-energie-academy-logo.svg')" alt="cva-energie-academy-logo" height="80"></b-img>
        </div> -->
        <div class="d-none d-md-block caption m-3 p-3">
            <h1 class="text-white">Telefonata o visita sospetta?<br>Non siamo noi<span class="cerchio-punto"></span></h1>
        </div>
        <div class="d-block d-md-none caption ml-1 mr-3 my-3 p-3">
            <h1 class="text-white">Telefonata o visita sospetta?<br>Non siamo noi<span class="cerchio-punto"></span></h1>
        </div>
      </div>
    </b-container>
    <b-container class="px-0 mx-0" fluid>
      <!-- DIV 2 -->
      <div class="div2 m-5 d-none d-md-block">
        <div class="d-flex position-relative div2-box-container align-items-center">
          <div class="w-100 bg-light div2-border-radius p-sm-5 mx-sm-5">
            <div class="div2-cerchio-l"></div>
            <div class="div2-cerchio-r"></div>
            <p v-html="testo21" class="mb-0 par-princ-font-size text-justify text-md-left"></p>
            <p v-html="testo22" class="mb-0 par-princ-font-size text-justify text-md-left"></p>
          </div>
          <div class="div2-border-radius p-sm-2 mx-sm-5 div2_2 position-absolute">
            <b-row align-v="center">
              <b-col cols=2 class="text-left"><b-img v-bind="mainProps" :src="require('../assets/immagini/attention_icon.svg')" class="m-3"></b-img></b-col>
              <b-col class="text-center"><p v-html="testo23" class="mb-0 testo_att text-justify text-md-center text-white"></p></b-col>
              <b-col cols=2 class="text-right"><b-img v-bind="mainProps" :src="require('../assets/immagini/attention_icon.svg')" class="m-3"></b-img></b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="div2-xs mt-0 mb-5 d-block d-md-none">
        <div class="d-flex position-relative align-items-center">
          <div class="w-100 bg-light my-5 py-4 px-3">
            <p v-html="testo21" class="mb-0 par-princ-font-size text-justify text-md-left mx-4"></p>
            <p v-html="testo22" class="mb-0 par-princ-font-size text-justify text-md-left mx-4"></p>
            </div>
            <div class="p-sm-2 mx-sm-5 div2_2 position-absolute">
              <b-row align-v="center">
                <b-col class="text-center"><p v-html="testo23_xs" class="mb-0 testo_att text-center text-md-center text-white"></p></b-col>
              </b-row>
            </div>
        </div>
      </div>
      <!-- DIV 1 -->
      <div class="d-none d-md-block my-5 mx-md-3 px-3 py-5">
        <div class=" d-flex justify-content-center position-relative mb-5">
          <div class="pt-md-5 mt-md-3 text-center">
            <h1 class="cerchio-md"><span v-html="title1" class="div1-h1-color h1-testo"></span></h1>
          </div>
        </div>
        <b-row class="py-md-1">
          <b-col cols="12">
            <p v-html="testo11" class="par-princ-font-size text-justify text-md-left mx-sm-3 mx-md-4 mx-lg-5"></p>
          </b-col>
        </b-row>
        <b-row class="py-md-1">
          <b-col cols="12">
            <p v-html="testo12" class="par-princ-font-size text-justify text-md-left mx-sm-3 mx-md-4 mx-lg-5"></p>
          </b-col>
        </b-row>
        <b-row class="py-md-1">
          <b-col cols="12">
            <p v-html="testo13" class="par-princ-font-size text-justify text-md-left mx-sm-3 mx-md-4 mx-lg-5"></p>
          </b-col>
        </b-row>
      </div>
      <div class="d-block d-md-none mt-5 mb-3 mx-md-3 px-3 py-5">
        <div class="mt-4">
          <div class="d-flex justify-content-center position-relative mb-4">
            <div class="pt-md-5 mt-md-3 text-center">
              <h1 class="cerchio-sm"><span v-html="title1" class="div1-h1-color h1-testo"></span></h1>
            </div>
          </div>
          <b-row>
            <b-col cols="12">
              <p v-html="testo11" class="par-princ-font-size text-justify text-md-left mx-sm-3 mx-md-4 mx-lg-5"></p>
            </b-col>
          </b-row>
          <b-row class="py-md-1">
            <b-col cols="12">
              <p v-html="testo12" class="par-princ-font-size text-justify text-md-left mx-sm-3 mx-md-4 mx-lg-5"></p>
            </b-col>
          </b-row>
          <b-row class="py-md-1">
            <b-col cols="12">
              <p v-html="testo13" class="par-princ-font-size text-justify text-md-left mx-sm-3 mx-md-4 mx-lg-5"></p>
            </b-col>
          </b-row>
        </div>
      </div>
      <!-- DIV 5 -->
      <!-- <div class="div5 d-none d-md-block mt-5 pt-5">
        <div class="d-flex position-relative div5-box-container align-items-center">
          <div class="div5-box-image"></div>
          <div class="ml-auto w-50 bg-light rounded p-5 div5-box-text">
            <h2 v-html="div5Title1"></h2>
            <p v-html="div5Testo1" class="par-princ-font-size mb-3 mt-4 text-left"></p>
            <p v-html="div5Testo2" class="par-princ-font-size mb-3 text-left"></p>
            <p v-html="div5Testo3" class="par-princ-font-size mb-3 text-left"></p>
            </div>
        </div>
      </div> -->
      <div class="div5 d-none d-md-block mt-5 pt-5">
        <div class="d-flex position-relative div5-box-container align-items-center">
          <div class="div5-box-image"></div>
          <div class="ml-auto w-50 bg-light rounded p-5 div5-box-text">
            <h2 v-html="div5Title1"></h2>
            <b-row align-v="center">
              <b-col cols="1" class="text-center px-0"><span class="cerchio-elenco"></span></b-col>
              <b-col class="ml-5 ml-sm-4 ml-xl-2 pl-0"><p v-html="div5Testo1_xs" class="par-princ-font-size mb-3 mt-4 text-left"></p></b-col>
            </b-row>
            <b-row align-v="center">
              <b-col cols="1" class="text-center px-0"><span class="cerchio-elenco"></span></b-col>
              <b-col class="ml-5 ml-sm-4 ml-xl-2 pl-0"><p v-html="div5Testo2_xs" class="par-princ-font-size mb-3 mt-4 text-left"></p></b-col>
            </b-row>
            <b-row align-v="center">
              <b-col cols="1" class="text-center px-0"><span class="cerchio-elenco"></span></b-col>
              <b-col class="ml-5 ml-sm-4 ml-xl-2 pl-0"><p v-html="div5Testo3_xs" class="par-princ-font-size mb-3 mt-4 text-left"></p></b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="d-block d-md-none">
        <div class="d-flex position-relative align-items-end div5-xs-box-container">
          <div class="w-100 bg-light p-4">
            <h2 v-html="div5Title1"></h2>
            <b-row align-v="center">
              <b-col cols="1" class="text-center px-0"><span class="cerchio-elenco"></span></b-col>
              <b-col class="ml-3 pl-0"><p v-html="div5Testo1_xs" class="par-princ-font-size mb-3 mt-4 text-left"></p></b-col>
            </b-row>
            <b-row align-v="center">
              <b-col cols="1" class="text-center px-0"><span class="cerchio-elenco"></span></b-col>
              <b-col class="ml-3 pl-0"><p v-html="div5Testo2_xs" class="par-princ-font-size mb-3 mt-4 text-left"></p></b-col>
            </b-row>
            <b-row align-v="center">
              <b-col cols="1" class="text-center px-0"><span class="cerchio-elenco"></span></b-col>
              <b-col class="ml-3 pl-0"><p v-html="div5Testo3_xs" class="par-princ-font-size mb-3 mt-4 text-left"></p></b-col>
            </b-row>
          </div>
        </div>
      </div>
      <!-- DIV 8 -->
      <b-container class="pt-4 px-0 my-5">
        <b-row class="mb-5">
          <b-col cols="12">
            <h1 class="div8-cerchio"><span v-html="div8Title1" class="h1-testo"></span></h1>
          </b-col>
        </b-row>
        <b-row >
          <b-col cols="12" class="pl-0">
            <p class="par-princ-font-size px-3" v-html="div8Testo1"></p>
          </b-col>
        </b-row>
      </b-container>
      <Form />
    </b-container>
      <b-container fluid class="div-footer text-center px-0 mx-0">
        <b-row class="py-5">
          <b-col>
            <b-link class="mx-2 mx-xs-0 mx-sm-3 mx-md-4 mx-lg-5 link-social" href="https://twitter.com/Gruppo_CVA"><b-img :src="require('../assets/immagini/twitter.svg')" class="m-3"></b-img></b-link>
            <b-link class="mx-2 mx-xs-0 mx-sm-3 mx-md-4 mx-lg-5 link-social" href="https://www.instagram.com/cva.energie"><b-img :src="require('../assets/immagini/instagram.svg')" class="m-3"></b-img></b-link>
            <b-link class="mx-2 mx-xs-0 mx-sm-3 mx-md-4 mx-lg-5 link-social" href="https://www.youtube.com/user/gruppocva"><b-img :src="require('../assets/immagini/youtube.svg')" class="m-3"></b-img></b-link>
            <b-link class="mx-2 mx-xs-0 mx-sm-3 mx-md-4 mx-lg-5 link-social" href="https://www.linkedin.com/company/530565"><b-img :src="require('../assets/immagini/linkedin.svg')" class="m-3"></b-img></b-link>
            <b-link class="mx-2 mx-xs-0 mx-sm-3 mx-md-4 mx-lg-5 link-social" href="https://www.facebook.com/CVAEnergie"><b-img :src="require('../assets/immagini/facebook.svg')" class="m-3"></b-img></b-link>
          </b-col>
        </b-row>
        <b-row class="text-white">
          <b-col>
            <b-link href="https://www.cvaenergie.it/service-page/privacy" class="mr-2" target="_blank">Privacy</b-link> | 
            <b-link href="https://www.iubenda.com/privacy-policy/88057413/cookie-policy" class="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe mx-2" title="Cookie Policy ">Cookie Policy</b-link> |
            <b-link href="#" class="iubenda-cs-preferences-link ml-2">Modifica preferenza cookies</b-link>
          </b-col>
        </b-row>
        <b-row align-v="end" class="pt-5">
          <b-col>
            <p class="font-footer text-light text-center w-100"><span v-html="this.divFooterText"></span></p>
          </b-col>
        </b-row>
      </b-container>
  </div>
</template>

<style lang="scss">
a {
  text-decoration: none !important;
  color: #fff !important;
}

a:hover {
  text-decoration: underline !important;
  // font-weight: 600 !important;
  color: #fff !important;
}
</style>

<script>
// @ is an alias to /src
import Form from '@/components/Form'

export default {
  name: 'Home',
  components: {
    Form
  },
  data: function() {
    return {
      imageTopProps: { height: 500, class:'w-100' },
      title1: 'Facciamo un po\' di chiarezza',
      testo11: `Diversi operatori energetici fanno delle vere e proprie campagne "<span class="text-blue">Acchiappaclienti</span>" e si fingono CVA Energie per fare leva sulla fiducia
                che le persone hanno nei nostri confronti.`,
      testo12:`Spesso infatti riceviamo numerose chiamate in cui le persone ci raccontano di aver ricevuto <span class="text-blue">una chiamata o una visita "sospetta"</span> da parte
              di soggetti che dicono di fare parte di CVA Energie e che, con la scusa di un aumento di tariffe o della scadenza del contratto, <span class="text-blue">propongono
              offerte e soluzioni di altri fornitori</span>.`,
      testo13:`Per facilitare l'invio delle tue segnalazioni abbiamo creato questo modulo.<br>
               Aiutaci a prevenire questi episodi, <span class="text-blue">inconvenienti e dannosi</span> sia per te che per noi, compilando i seguenti campi.`,
      testo21: `Hai ricevuto visite o telefonate da operatori che si presentano come CVA Energie, che parlano di cambi <span class="text-danger text-bold-slim2">tariffari irripetibili</span>?`,
      testo22: `Ti hanno chiesto di mostrargli la tua bolletta e secondo loro è <span class="text-danger text-bold-slim2">troppo cara</span>?`,
      testo23: `Devi sapere che non siamo noi: si tratta di un tentativo di frode.`,
      testo23_xs: `Devi sapere che non siamo noi: si tratta di un tentativo di frode!`, 
      div5Title1: `Un nostro operatore<br> si riconosce così.`,
      div5Testo1: `<span class="cerchio-elenco"></span>Propone offerte trasparenti`,
      div5Testo2: `<span class="cerchio-elenco"></span>Chiama da numeri che puoi verificare`,
      div5Testo3: `<span class="cerchio-elenco"></span>&#200; chiaramente associabile a CVA Energie`,
      div5Testo1_xs: `Propone offerte trasparenti`,
      div5Testo2_xs: `Chiama da numeri che puoi verificare`,
      div5Testo3_xs: `&#200; chiaramente associabile a CVA Energie`,
      div8Title1: `Invia segnalazione`,
      div8Testo1: `Fai il primo passo per avere un mercato più trasparente, non solo per te ma anche per tutti gli altri consumatori.`,
      divFooterText:`CVA Energie S.r.l. a s.u. - Società soggetta all'attività di direzione e coordinamento di C.V.A. S.p.A. a s.u. - C.F. P.IVA e numero di iscrizione presso il registro 
                     delle Imprese di Aosta 01032450072 C.S. € 3.000.000,00 i.v.<br>
                     <span class="text-bold-slim">Via Stazione n.31 - 11024 Châtillon – Valle d’Aosta – Italia | 2020-Copyright CVA Energie S.r.l. a s.u</span>`,
      div4Visible: false,
      div6Visible: false,
      mainProps: { width: 50, height: 50}
    }
  },
  methods:{
    div4Visibility(visible) {
      this.div4Visible = visible 
    },
    div6Visibility(visible) {
      this.div6Visible = visible 
    }
  }
}
</script>
